import L from "leaflet";
import iconUrl from "leaflet/dist/images/marker-icon.png";
export const icon = L.icon({
  iconUrl,
});
